import React from 'react';
import {
  IndexContainer,
  IndexLine,
  StepContainer,
  StepIndicatorContainer,
  StepWrapper,
  StepsContainer,
  StepsContainerMask,
} from './styles';

interface StepIndicatorProps {
  titles: string[];
  activeIndex: number;
}

export const StepIndicator: React.FC<StepIndicatorProps> = ({
  titles,
  activeIndex,
}) => {
  return (
    <StepIndicatorContainer>
      <StepsContainer>
        {titles.map((title, index) => (
          <StepWrapper key={title}>
            <StepContainer>
              <IndexContainer isActive={index === activeIndex}>
                <span>{index + 1}</span>
              </IndexContainer>
              <span>{title}</span>
            </StepContainer>
          </StepWrapper>
        ))}
        <StepsContainerMask>
          {titles.map((title, index) => (
            <React.Fragment key={title}>
              <IndexContainer isActive={index === activeIndex}>
                <span>{index + 1}</span>
              </IndexContainer>
              {index + 1 !== titles.length && <IndexLine />}
            </React.Fragment>
          ))}
        </StepsContainerMask>
      </StepsContainer>
    </StepIndicatorContainer>
  );
};
